import { getFromWeekCinemaEndDate, getFromWeekCinemaStartDate } from '../../../functions/getDateFromWeek'
import { propContainerWidth, tableProps, tdProps } from './helpersProps'
import NewsletterSectionAds from './NewsletterSectionAds'
import NewsletterSectionCinema from './NewsletterSectionCinema'
import NewsletterSectionHighlights from './NewsletterSectionHighlights'
import NewsletterSectionMovies from './NewsletterSectionMovies'
import NewsletterSectionText from './NewsletterSectionText'
import NewsletterSectionImage from './NewsletterSectionImage'
import NewsletterSectionSocialMedia from './NewsletterSectionSocialMedia'
import NewsletterFooter from './NewsletterFooter'
import NewsletterSectionLogo from './NewsletterSectionLogo'
import NewsletterSectionMoviesPerformances from './NewsletterSectionMoviesPerformances'

const Newsletter = ({
    stylesData, 
    structureData, 
    cinemaData, 
    cinemasData, 
    newsletterData, 
    ads, 
    currentCinemaUrl, 
    imageItems, 
    textItems, 
    socialMediaData, 
    highlights, 
    movieData, 
    allPerformances, 
    closingTextLines, 
    translation, 
    routeMovies
}) => {
    if(!cinemaData.week)  {  // Dirty Quick Fix
        return null
    }
    
    const startDate = getFromWeekCinemaStartDate(cinemaData.week.isoWeek, cinemaData.week.year)
    const endDate = getFromWeekCinemaEndDate(cinemaData.week.isoWeek, cinemaData.week.year)

    return (
        <center>
            <table id="bodyTable" {...tableProps} height="100%" style={{background: stylesData.newsletterBackground}}>
                <tbody>
                    <tr>
                        <td id="bodyCell" {...tdProps} style={{padding: "31px 15px 185px 15px"}}>

                            <table id="emailBody" {...{...tableProps, ...propContainerWidth}}>
                                <tbody>
                                    <NewsletterSectionLogo
                                        cinemaData={cinemaData}
                                        paddingRight="40px"
                                        paddingLeft="40px"
                                    />
                                    
                                    {structureData.order.map((structureId) => {
                                        const structureItemData = structureData.items[structureId]
                                        const type = structureItemData.itemType
                                        return (
                                            'week' === type ? (
                                                <NewsletterSectionCinema 
                                                    key={structureId}
                                                    cinemaData={cinemaData}
                                                    stylesData={stylesData}
                                                    startDate={startDate}
                                                    endDate={endDate}
                                                    translation={translation}
                                                />
                                            ) : 'content' === type ? (
                                                <NewsletterSectionAds 
                                                    key={structureId}
                                                    id={structureId}
                                                    newsletterData={newsletterData}
                                                    structureItemData={structureItemData}
                                                    items={ads}
                                                    movieData={movieData}
                                                    stylesData={stylesData}
                                                    cinemaData={cinemaData}
                                                    translation={translation}
                                                />
                                            ) : 'highlights' === type ? (
                                                <NewsletterSectionHighlights 
                                                    key={structureId}
                                                    id={structureId}
                                                    items={highlights}
                                                    cinemaData={cinemaData}
                                                    newsletterData={newsletterData}
                                                    movieData={movieData}
                                                    stylesData={stylesData}
                                                    translation={translation}
                                                />
                                            ) : 'movies' === type ? (
                                                <NewsletterSectionMovies 
                                                    key={structureId}
                                                    id={structureId}
                                                    items={movieData}
                                                    cinemaData={cinemaData}
                                                    newsletterData={newsletterData}
                                                    structureItemData={structureItemData}
                                                    stylesData={stylesData}
                                                    translation={translation}
                                                />                                            
                                            ) : 'movie_performances' === type ? (
                                                <NewsletterSectionMoviesPerformances 
                                                    key={structureId}
                                                    id={structureId}
                                                    movieData={movieData}
                                                    allPerformances={allPerformances}
                                                    cinemaData={cinemaData}
                                                    cinemasData={cinemasData}
                                                    newsletterData={newsletterData}
                                                    structureItemData={structureItemData}
                                                    startDate={startDate}
                                                    endDate={endDate}
                                                    stylesData={stylesData}
                                                    translation={translation}
                                                    routeMovies={routeMovies}
                                                    currentCinemaUrl={currentCinemaUrl}
                                                />                                                
                                            ) : 'text' === type ? (
                                                <NewsletterSectionText 
                                                    key={structureId}
                                                    id={structureId}
                                                    items={textItems}
                                                    newsletterData={newsletterData}
                                                    stylesData={stylesData}
                                                />
                                            ) : 'image' === type ? (
                                                <NewsletterSectionImage
                                                    key={structureId}
                                                    id={structureId}
                                                    items={imageItems}
                                                    newsletterData={newsletterData}
                                                    stylesData={stylesData}
                                                    translation={translation}
                                                />
                                            ) : 'social_media' === type ? (
                                                <NewsletterSectionSocialMedia
                                                    key={structureId}
                                                    id={structureId}
                                                    currentCinemaUrl={currentCinemaUrl}
                                                    items={socialMediaData}
                                                    newsletterData={newsletterData}
                                                    translation={translation}
                                                />
                                            ) : null
                                        )
                                    })}

                                    <NewsletterFooter
                                        stylesData={stylesData}
                                        cinemaData={cinemaData}
                                        translation={translation}
                                        socialMediaData={socialMediaData}
                                        closingTextLines={closingTextLines}
                                        currentCinemaUrl={currentCinemaUrl}
                                    />
                                </tbody>
                            </table>
                        </td>
                    </tr>
                </tbody>
            </table>
        </center>
    )
}

export default Newsletter